import { render, staticRenderFns } from "./TVTwo.vue?vue&type=template&id=48d4411f&scoped=true&"
import script from "./TVTwo.vue?vue&type=script&lang=js&"
export * from "./TVTwo.vue?vue&type=script&lang=js&"
import style0 from "./TVTwo.vue?vue&type=style&index=0&id=48d4411f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d4411f",
  null
  
)

export default component.exports